import { api } from "../../apis/account";
import { WebApiRequest, HTTP_GET, HTTP_POST, HTTP_PUT } from "../../tools/webservice";

export const getEmployeeDetails = (internetUserId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getEmployeeDetails(internetUserId),
  successCallback,
  mountedRef
});

export const updateEmployeeDetails = (internetUserId, employeeDetails, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  payload: employeeDetails,
  endpoint: api.updateEmployeeDetails(internetUserId),
  successCallback,
  mountedRef
});

export const getEmployeeNotes = (internetUserId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getEmployeeNotes(internetUserId),
  successCallback,
  mountedRef
});

export const addEmployeeNote = (employeeNote, internetUserId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: api.addEmployeeNote(internetUserId),
  payload: employeeNote,
  successCallback,
  mountedRef
});

export const approvePayPeriodUser = (payPeriodId, internetUserId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: api.approvePayPeriodUser(payPeriodId, internetUserId),
  successCallback,
  mountedRef
});

